import { render } from "./DatasetLayout.vue?vue&type=template&id=60e73a30"
import script from "./DatasetLayout.vue?vue&type=script&lang=js"
export * from "./DatasetLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__